import React from 'react'

function Seventh() {
  return (
    <section className='seven'>
        <h1>LET'S HELP <br /> YOU GROW YOUR BUSINESS</h1>
        <button>Download the App</button>
    </section>
  )
}

export default Seventh